import DataType from '../../Config/DataStructure';
import { RoundPlayOverviewDataType, RoundPlayPreviewDataType, RoundPlayStatsDataType } from '../../Config/GamePreviewDataType';
import CommonGamePreviewData from './CommonGamePreviewData';

export default class RoundPlayGamePreviewData extends CommonGamePreviewData implements RoundPlayPreviewDataType {
    constructor(hallID: number, gameID: string, playType: DataType.Enums.PlayType, data: RoundPlayOverviewDataType) {
        super(hallID, gameID, playType, data);
    }

    public updateOverviewData(data: RoundPlayOverviewDataType) {
        super.updateOverviewData(data);
    }

    public updateStatsData(data: RoundPlayStatsDataType) {
        super.updateStatsData(data);
    }
}
